<template>
	<div class="version_item">
		<div class="title">
			<span class="version_num">{{versionData.version}}
				<slot></slot>
			</span>
			<span class="version_time">{{versionData.create_time}}</span>
		</div>
		<div class="content">
			<div class="version_content"
				:class="{version_active: isActive}"
				style="white-space: pre-line;"
				v-html="versionData.remark"></div>
			<el-button type="text"
				@click="isActive=!isActive"
				style="padding-bottom: 0;">{{isActive?"收起":"全部"}}</el-button>
		</div>
	</div>
</template>

<script>
export default{
	name: "versionsItem",
	props: ["versionData"],
	data() {
		return {
			isActive: false
		}
	}
}
</script>

<style lang="scss" scoped>
.version_item {
	border: 1px solid #D8D8D8;
	border-radius: 8px;
	padding: 18px 15px;
	margin-bottom: 14px;
	.title{
		display: flex;
		justify-content: space-between;
	}
}
.version_num {
	font-size: 16px;
	font-weight: 600;
	color: #172B4D;
	line-height: 22px;
}

.version_time {
	font-size: 16px;
	font-weight: 400;
	color: #838A9D;
	line-height: 22px;
}
.content{
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: flex-start;

	.version_content {
		font-size: 14px;
		font-weight: 400;
		color: #838A9D;
		line-height: 20px;

		margin-top: .5em;
		overflow: hidden;
		box-sizing: border-box;
		height: 20px;
		transition: height .5s;
	}

	.version_active{
		height: max-content;
	}
}

</style>